/**
 * The `/register` page body (`pages/register/index.tsx`): the sign-up form
 * (`RegisterForm.tsx`, registration step 1) beside a dark panel listing what an account gives
 * (`AccountForm.tsx`). From the `lg` breakpoint the two sit side by side on a white/dark-grey
 * split; below it they stack.
 */
import React from "react";
import { useTheme } from "@ryerson/frontend.theme";
import { ContentSection, Flex, SplitConfig } from "@ryerson/frontend.layout";
import { Media } from "@ryerson/frontend.next";
import RegisterForm from "./RegisterForm";
import AccountForm from "./AccountForm";
import { useHasMounted } from "@components/Hooks";

/** Lays out the registration form and the account-benefits panel. Renders nothing until mounted. */
const Register: React.FC = () => {
	const { theme } = useTheme();
	if (!useHasMounted()) return null;

	const loginSection: SplitConfig = {
		splitDirection: "horizontal",
		splitColors: [
			{
				color: theme.colors.primary.white,
				percentage: "50%",
			},
			{
				color: theme.colors.primary.darkGray,
				percentage: "50%",
			},
		],
	};
	const createAccountSection: SplitConfig = {
		splitDirection: "vertical",
		splitColors: [
			{
				color: theme.colors.primary.darkGray,
				percentage: "100%",
			},
		],
	};

	return (
		<React.Fragment>
			<Media greaterThanOrEqual="lg">
				<ContentSection type="split" split={loginSection} vPadding="0" hPadding="0">
					<Flex justifyContent="space-evenly">
						<RegisterForm isMobile={false} />
						<AccountForm isMobile={false} />
					</Flex>
				</ContentSection>
			</Media>
			<Media lessThan="lg">
				<ContentSection>
					<RegisterForm isMobile={true} />
				</ContentSection>
				<ContentSection type="split" split={createAccountSection}>
					<AccountForm isMobile={true} />
				</ContentSection>
			</Media>
		</React.Fragment>
	);
};

export default Register;
